// extracted by mini-css-extract-plugin
export default {"menuContent":"MenuContent_menuContent__s9kz8","active":"MenuContent_active__gYWgt"};